import { IResourceBase } from '../shared/utils/resourcefiles.utils';

export type ResourceStatus = 'Ok' | 'Bad' | 'BadDependency';
/**
 * Artifact loading status.
 * * `'Ok'`: Resource is loaded successfully.
 * * `'Stub'`: The resource content is currently empty. It's not loaded until you call `ModelService.fetch`.
 */
export enum LoadingStatusEnum {
    Ok = 'Ok',
    Stub = 'Stub',
    InvalidJson = 'InvalidJson',
    NameMismatch = 'NameMismatch',
    TypeMismatch = 'TypeMismatch',
    SubTypeMismatch = 'SubTypeMismatch',
    MissingSubType = 'MissingSubType',
    InvalidType = 'InvalidType',
    RenameNotAllowed = 'RenameNotAllowed',
    NameNotUnique = 'NameNotUnique',
    UnknownError = 'UnknownError',
    UpdateObjectIdNotAllowed = 'UpdateObjectIdNotAllowed'
}
export type LoadingStatus = LoadingStatusEnum;

export type Operation = 'add' | 'delete' | 'rename' | 'update';

export interface ICommitChange {
    operation: Operation;
    resource: IResourceBase;
    payload?: ICommitPayload;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface ICommitPayload { }
